import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';
import Tooltip from '@creditflowresearch/uilib/Tooltip';

const getCell = ({ row: tranche } : ITranchRow) => (
  <Tooltip content={ tranche.size.name }>
    { tranche.size.displayName }
  </Tooltip>
);

const CurrencyCell = ({ rowIndex, tranche, className } : ICellProps) => (
  <BodyCell
    name="CurrencyCell"
    className={ className }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default CurrencyCell;
